import styled from "@emotion/styled";
import Close from "@mui/icons-material/Close";

export const LeavePageModalWrapper = styled.div(({ theme }) => ({
	width: "552px",
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	background: theme.project.colors.backgroundColors.main,
	padding: "1rem 1.5rem 1.5rem 1.5rem",
	boxShadow: "1.5rem",
	borderRadius: ".25rem",
	h6: {
		...theme.project.typography.heading.h6,
		margin: "0 0 1rem 0",
		color: theme.project.colors.fontColors.secondary
	},
	p: {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.secondary,
		margin: "0 0 1rem 0"
	},
	div: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
		justifyContent: "space-between"
	},
	[theme.breakpoints.down("lg")]: {
		width: "257px",
		h6: {
			margin: "0 2rem 1rem 0"
		},
		div: {
			flexDirection: "column",
			alignItems: "center",
			height: "100px"
		}
	}
}));

export const CloseModalButton = styled(Close)(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary,
	width: "1.5rem",
	height: "1.5rem",
	position: "absolute",
	top: "1rem",
	right: "1rem",
	cursor: "pointer",
	[theme.breakpoints.down("lg")]: {
		top: "2rem",
		right: "2rem"
	}
}));

export const LeavePageModalButtons = styled.div(({ theme }) => ({
	button: {
		width: "268px",
		margin: 0
	},
	[theme.breakpoints.down("lg")]: {
		button: {
			width: "257px"
		}
	}
}));
